// extracted by mini-css-extract-plugin
module.exports = {"radioWrapper":"InputRadio_radioWrapper__VLFsv","radio":"InputRadio_radio__zFt8P","label":"InputRadio_label__3COpZ"};